import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { LoadingButton } from "@material-ui/lab";
import PropTypes from "prop-types";

MyConfirmationDialog.props = {
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
  title: PropTypes.string,
  content: PropTypes.string,
  open: PropTypes.bool,
  loading: PropTypes.bool,
};

export default function MyConfirmationDialog({
  onSubmit,
  onClose,
  title,
  content = "",
  open,
  loading = false,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          Cancelar
        </Button>
        <LoadingButton
          autoFocus
          color="primary"
          onClick={onSubmit}
          loading={loading}
        >
          Aceptar
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
